/* eslint no-unused-vars:0 */

import axios from "axios";

export const constants = {
    namespaced: true,
    state: {
        typeLabels: {},
        iavAccountOwnerTypes: {},
    },
    actions: {
        loadConstants ({ commit }) {
            return axios
                .get('/api/constants')
                .then(response => {
                    commit('setConstants', response.data.data);
                    return response;
                })
        },
    },
    mutations: {
        setConstants (state, data) {
            state.typeLabels = data.typeLabels;
            state.iavAccountOwnerTypes = data.iavAccountOwnerTypes;
        },
    },
    getters: {
        getAccountType(state) {
            return type => {
                const item = state.typeLabels.find(i => i.value === type);
                if (item !== undefined) {
                    return item.text;
                }

                return 'Other';
            }
        },
    }
};
